/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import DropDownComponent from './DropDownComponent';
import { dataService } from '../../../../../../../services/data.services';
import CustomeDatePicker from './CustomDatePicker';
import Loader from '../../../../../../../components/Loader';

export default function Filter({
    searchParams,
    setSearchParams, 
    academicYearsDropdownOptions,
    financialYearsDropdownOptions,  
    setAcademicYearsDropdownOptions,
    startDate,
    setApiIsLoading,
    endDate,
    setStartDate, 
    setEndDate,
    apiIsLoading,
    setToastErrorMessage,
    getStudentData,
    currentFinacialYear,
    setInvoiceStatus}){

    /* The below code is defining a constant variable called `dateRangeDropdownOptions` which is an array
    of objects. Each object has a property `name` with a corresponding value. The array contains three
    objects representing different options for a dropdown menu: 'Financial Year', 'Academic Year', and
    'Custom'. */
    const dateRangeDropdownOptions = [{ name: 'Financial Year' }, { name: 'Academic Year' }, { name: 'Custom' }];
    /* The below code is defining an array called `invoiceDropdownOptions` which contains three objects.
    Each object has a property `name` with a different value. These objects represent options for a
    dropdown menu, specifically for selecting different types of invoices. */
    const invoiceDropdownOptions = [{ name: 'All' }, { name: 'Invoices With Due' }, { name: 'Paid' }];
    
    //use this const to disable the dropdowns below (Tailwind for disabled dropdown is already there)
    const dropDownDisabled = true

    const [isDateWrong, setIsDateWrong] = useState(false)

    const arrayToMapAY = Array.isArray(academicYearsDropdownOptions)
        ? academicYearsDropdownOptions
        : [academicYearsDropdownOptions];

    const arrayToMapFY = Array.isArray(financialYearsDropdownOptions)
        ? financialYearsDropdownOptions
        : [financialYearsDropdownOptions];

    /**
     * The function `updateNameWithStatus` takes an array of objects and returns a new array with each
     * object's name property updated to include the capitalized status.
     * @returns a new array where each item has its name updated with its status in parentheses.
     */
    function updateNameWithStatus(array) {
        return array?.map(item => {
            const originalEndDate = new Date(item?.end_date);
            const modifiedEndDate = new Date(originalEndDate.setDate(originalEndDate.getDate() - 1));
      
            return {
                ...item,
                name: `${item?.name} (${new Date(item?.start_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })} - ${modifiedEndDate.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })}) (${item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)})`
            };
        });
    }
    
    const updatedAcademicYearsDropdownOptions = updateNameWithStatus(arrayToMapAY);
    const updatedFYDropdownOptions = updateNameWithStatus(arrayToMapFY);

    // Find the item that matches the ongoing financial year
    const ongoingFY = updatedFYDropdownOptions.find(item => item.name.includes(currentFinacialYear));
    let formattedCurrentFY = ''
    // Check if the ongoingFY is found
    if (ongoingFY) {
        // Format the start and end dates
        const formattedStartDate = new Date(ongoingFY.start_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
        const formattedEndDate = new Date(ongoingFY.end_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
        // Construct the variable in the desired format
        formattedCurrentFY = `${ongoingFY.name}`;
    } 

    /**
     * The function `selectedFY` returns the name of a financial year from a dropdown options array based
     * on a given start date.
     * @returns The function `selectedFY` returns the name of the financial year from the
     * `updatedFYDropdownOptions` array that matches the `start_date` value obtained from the
     * `searchParams` object. If no match is found, an empty string is returned.
     */
    const selectedFY = () => {
        for (let i = 0; i < updatedFYDropdownOptions?.length; i++) {
            const fyStartDate = updatedFYDropdownOptions[i]?.start_date;
            const fyStartDateOnlyDate = fyStartDate?.split('T')[0];
  
            if (fyStartDateOnlyDate === searchParams?.get('start_date')) {
                return updatedFYDropdownOptions[i]?.name;
            } 
            const currentFinancialYearObject = updatedFYDropdownOptions.find(
                (year) => year.name === formattedCurrentFY
            );
            if (currentFinancialYearObject && (searchParams?.get('date_range') === 'Financial Year')) {
                setStartDate(currentFinancialYearObject.start_date.substring(0, 10));
                setEndDate(currentFinancialYearObject.end_date.substring(0, 10));
                return formattedCurrentFY
            }
        }
        return '';
    };
  
    /**
     * The function `selectedAY` returns the name of the academic year from a dropdown options array based
     * on a given start date.
     * @returns The function `selectedAY` returns the name of the academic year that matches the start date
     * provided in the search parameters. If no match is found, an empty string is returned.
     */
    const selectedAY = () => {
        for (let i = 0; i < updatedAcademicYearsDropdownOptions?.length; i++) {
            const ayStartDate = updatedAcademicYearsDropdownOptions[i]?.start_date;
            const ayStartDateOnlyDate = ayStartDate?.split('T')[0];
            if (ayStartDateOnlyDate === searchParams?.get('start_date')) {
                return updatedAcademicYearsDropdownOptions[i].name;
            }
        }

        const currentAYObject = updatedAcademicYearsDropdownOptions[0];

        //first AY is the current AY of student, make it default
        if (currentAYObject && (searchParams?.get('date_range') === 'Academic Year')) {
            setStartDate(currentAYObject?.start_date?.substring(0, 10));
            setEndDate(currentAYObject?.end_date?.substring(0, 10));
            return updatedAcademicYearsDropdownOptions[0]?.name;
        }
        return '';
    };

    const selFY = selectedFY()
    const selAY = selectedAY()
    
    /* The below code is a React functional component that uses the useState hook to initialize and manage
    the state of a dropdown value. The state variable is called `dropDownValue` and it is initialized
    with an object that has three properties: 'date-range', 'selectFY', and 'invoice'. */
    const [dropDownValue, setDropDownValue] =useState({
        'date-range': searchParams?.get('date_range') !== null ? searchParams?.get('date_range') : 'Financial Year',
        'selectFY': selFY,
        'selectAY': selAY,
        'invoice': searchParams?.get('invoice_stauts') !== null ? searchParams?.get('invoice_stauts') : 'All'
    })

    //The function `handleOnchangeInput` updates the each's dropdowns state based on the selected dropdown and it's value.
    const handleOnchangeInput = (id, item, index) => {
        setIsDateWrong(false)
        setToastErrorMessage('')
        let newSearchParams = Object.fromEntries(searchParams);
        setDropDownValue((prev) => {
            if (id === "Date Range") {
                newSearchParams.date_range = item.name;
                newSearchParams.invoice_stauts = 'All'
                setSearchParams(newSearchParams);
                if((prev['date-range'] === 'Academic Year' || prev['date-range'] === 'Custom') &&  item.name === 'Financial Year'){
                    const currentFinancialYearObject = financialYearsDropdownOptions.find(
                        (year) => year.name === currentFinacialYear
                    );
                    setStartDate(currentFinancialYearObject.start_date.substring(0, 10));
                    setEndDate(currentFinancialYearObject.end_date.substring(0, 10));
                    newSearchParams.start_date = currentFinancialYearObject.start_date.substring(0, 10);
                    newSearchParams.end_date = currentFinancialYearObject.end_date.substring(0, 10);
                    newSearchParams.invoice_stauts = 'All'
                    setSearchParams(newSearchParams);
                }
                else if((prev['date-range'] === 'Financial Year' || prev['date-range'] === 'Custom') &&  item.name === 'Academic Year'){
                    return {
                        ...prev,
                        'date-range': item.name,
                        'selectAY': '',
                        'invoice': 'All'
                    };
                }
                else if(item.name === 'Custom'){
                    return {
                        ...prev,
                        'date-range': item.name,
                        'selectAY': '',
                        'invoice': 'All'
                    }
                }
                return {
                    ...prev,
                    'date-range': item.name,
                    'invoice': 'All'
                };
            } else if (id === "Select FY") {
                const selectedFY = updatedFYDropdownOptions.find((fy) => fy.name === item.name);
                if (selectedFY) {
                    setStartDate(selectedFY.start_date.substring(0, 10));
                    setEndDate(selectedFY.end_date.substring(0, 10));
                    newSearchParams.start_date = selectedFY.start_date.substring(0, 10);
                    newSearchParams.end_date = selectedFY.end_date.substring(0, 10);
                    newSearchParams.invoice_stauts = 'All'
                    setSearchParams(newSearchParams);
                }
                return {
                    ...prev,
                    'selectFY': item.name,
                    'selectAY': '',
                    'invoice': 'All'
                }
            } else if (id === "Select AY") {
                const selectedAY = updatedAcademicYearsDropdownOptions.find((ay) => ay.name === item.name);
                if (selectedAY) {
                    setStartDate(selectedAY.start_date.substring(0, 10));
                    setEndDate(selectedAY.end_date.substring(0, 10));
                    newSearchParams.start_date = selectedAY.start_date.substring(0, 10);
                    newSearchParams.end_date = selectedAY.end_date.substring(0, 10);
                    newSearchParams.invoice_stauts = 'All'
                    setSearchParams(newSearchParams);
                } 
                return {
                    ...prev,
                    'selectAY': item.name,
                    'selectFY': '',
                    'invoice': 'All'
                };
            } else if (id === "Invoice Status") {
                setInvoiceStatus(item.name)
                newSearchParams.invoice_stauts = item.name;
                setSearchParams(newSearchParams);
                return {
                    ...prev,
                    'invoice': item.name
                };
            }
            return prev;
        });
    };


    /**
     * The function handleApplyFilter calls the getStudentData function again.
     */
    const handleApplyFliter = () => {
        setToastErrorMessage('')
        setIsDateWrong(false)
        const startDateObj = new Date(startDate);
        const endDateObj = new Date(endDate);
    
        if (startDateObj > endDateObj) {
            setToastErrorMessage('Start Date cannot exceed End Date');
            setIsDateWrong(true);
            return;
        } else {
            setApiIsLoading(true)
            getStudentData();    
        }
    };

    /**
     * The function `handleDateSelect` takes in an id, date, dateString, and termkey, and formats the date
     * in the "YYYY-MM-DD" format before setting the start or end date based on the id.
     */
    const handleDateSelect = (id, date, dateString, termkey) =>{
        const startDateObj = new Date(startDate);
        const endDateObj = new Date(endDate);
        setIsDateWrong(false)
        let newSearchParams = Object.fromEntries(searchParams);
        let newdate = new Date(dateString);
        // Get the year, month, and day from the Date object
        let year = newdate.getFullYear();
        let month = ("0" + (newdate.getMonth() + 1)).slice(-2); // Adding 1 because months are zero-based
        let day = ("0" + newdate.getDate()).slice(-2);
        // Format the date in the desired format "YYYY-MM-DD"
        let formattedDate = year + "-" + month + "-" + day;
        if(id === 'custom-start-date'){
            setStartDate(formattedDate)
            newSearchParams.start_date = formattedDate;
            setSearchParams(newSearchParams);
            if (new Date(formattedDate) > endDateObj) {
                setToastErrorMessage('Start Date cannot exceed End Date');
                setIsDateWrong(true);
                return;
            }
        } else if (id === 'custom-end-date'){
            setEndDate(formattedDate)
            newSearchParams.end_date = formattedDate;
            setSearchParams(newSearchParams);
            if (startDateObj > new Date(formattedDate)) {
                setToastErrorMessage('Start Date cannot exceed End Date');
                setIsDateWrong(true);
                return;
            }
        }
    }

    return(
        <div className="flex h-[6.25rem] border border-[#d0d5dd]">
            {/* Date range dropdown */}
            <div className="inline-flex flex-col justify-center items-start gap-1 p-[16px]">
                <p className="date_range text-black leading-6 text-f7">Invoice Date Range</p>
                <DropDownComponent
                    dropDownName={"Date Range"}
                    id={"Date Range"}
                    test_id={"Date Range"}
                    divClassName={`relative w-[150px]  z-40`}
                    value={dropDownValue["date-range"]}
                    placeHolder={"Date Range"}
                    buttonDisabled={false}
                    options={dateRangeDropdownOptions}
                    handleOnchangeInput={handleOnchangeInput}
                    tooltip={true} />
            </div>
            {/* Finacial Year dropdown */}
            {dropDownValue['date-range'] === 'Financial Year' && <div className="inline-flex flex-col items-start gap-1 py-[16px] pr-[16px]">
                <p className="select_fy text-black leading-6 text-f7">Select FY</p>
                <DropDownComponent
                    dropDownName={"Select FY"}
                    id={"Select FY"}
                    test_id={"Select FY"}
                    divClassName={"relative w-[200px] z-40"}
                    value={dropDownValue?.selectFY===""?formattedCurrentFY:dropDownValue?.selectFY}
                    // placeHolder={"Select FY"}
                    buttonDisabled={false}
                    options={updatedFYDropdownOptions}
                    handleOnchangeInput={handleOnchangeInput}
                    tooltip={true} />

            </div> }
            {/* Academic Year dropdown */}
            {dropDownValue['date-range'] === 'Academic Year' &&  <div className="inline-flex flex-col items-start gap-1 py-[16px] pr-[16px]">
                <p className="select_ay text-black leading-6 text-f7">Select AY</p>
                <DropDownComponent
                    dropDownName={"Select AY"}
                    id={"Select AY"}
                    test_id={"Select AY"}
                    divClassName={"relative w-[200px] z-40"}
                    value={dropDownValue.selectAY===""?updatedAcademicYearsDropdownOptions[0]?.name:dropDownValue.selectAY}
                    placeHolder={"Select AY"}
                    buttonDisabled={false}
                    options={updatedAcademicYearsDropdownOptions}
                    handleOnchangeInput={handleOnchangeInput}
                    tooltip={true} />
            </div>}
            {/* Custom DateRange dropdowns */}
            {dropDownValue['date-range'] === 'Custom' &&  <div className='flex'>
                <div className="inline-flex flex-col items-start gap-1 py-[16px] pr-[16px]">
                    <p className="select_ay text-black leading-6 text-f7">Start Date</p>
                    <CustomeDatePicker 
                        id='custom-start-date'
                        showErrorBorder={isDateWrong}
                        format="MMM DD, YYYY"
                        state={searchParams?.get('start_date') !== null ? searchParams?.get('start_date') : startDate}
                        placeholder="Select Start Date"                                
                        imageClass={true}
                        handleSelect={handleDateSelect}
                    />
                </div>
                <div className="inline-flex flex-col items-start gap-1 py-[16px] pr-[16px]">
                    <p className="select_ay text-black leading-6 text-f7">End Date</p>
                    <CustomeDatePicker 
                        id='custom-end-date'
                        showErrorBorder={isDateWrong}
                        format="MMM DD, YYYY"
                        state={searchParams?.get('end_date') !== null ? searchParams?.get('end_date') : endDate}
                        placeholder="Select End Date"                                
                        imageClass={true}
                        handleSelect={handleDateSelect}
                    />
                </div>
            </div>
            }
            {/* Invoice Status dropdown */}
            <div className="inline-flex flex-col items-start gap-1 py-[16px] pr-[16px]">
                <p className="select_invoice text-black leading-6 text-f7">Invoice Status</p>
                <DropDownComponent
                    dropDownName={"Invoice Status"}
                    id={"Invoice Status"}
                    test_id={"Invoice Status"}
                    listWidth={`w-[160px]`}
                    divClassName={`relative ${dropDownValue['date-range'] === 'Custom' ? 'w-[150px] 2xl:w-[180px]' : 'w-[180px]'} z-40`}
                    value={dropDownValue.invoice}
                    placeHolder={"Invoice Status"}
                    buttonDisabled={false}
                    options={invoiceDropdownOptions}
                    handleOnchangeInput={handleOnchangeInput}
                    tooltip={true} />
            </div>
            <div className="flex justify-center items-center ml-auto pr-[18px] pt-[22px]">
                <button onClick={handleApplyFliter} className={`actn-btn ${(dropDownValue['date-range']==='Academic Year' && dropDownValue.selectAY === '') ? 'bg-[#929394]' : 'bg-[#106eb4]'}`} style={{'width':'140px'}}
                    id='apply_filter' data-testid='apply_filter' disabled={apiIsLoading}>
                    {apiIsLoading ? <Loader/> : 'Apply Filter'}
                </button>
            </div>
        </div>
    );
}